import { useCallback, useEffect, useState } from 'react';
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import UserTable from "./UserTable";
import AddUserForm from "./AddUserForm";
import EditUserForm from "./EditUserForm";
import ChangePasswordForm from './ChangePasswordForm';
import CapteurList from './CapteurList';
import SearchCapteur from './SearchCapteur';
import UserCapteurList from './UserCapteurList';
import axios from 'axios';
import { API_URL } from '../constants';
import { FaUserCog, FaUserEdit } from 'react-icons/fa';

export default function Admin(props) {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : props.user;

    const userId = user.userId;

  const [users, setUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedUserEmail, setSelectedUserEmail] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCapteur, setSelectedCapteur] = useState(null);
  const [selectedIdCompteur,setSelectedIdCompteur] = useState(null);
  const [showMoteurList, setShowMoteurList] = useState(true);
  const [capteurs, setCapteurs] = useState([]);

  const fetchUsers = useCallback(async () => {
    try {
      const response = await axios.get(`${API_URL}/user/`, {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      });
      setUsers(response.data);
    } catch (error) {
      console.error("Erreur lors de la récupération des utilisateurs :", error);
    }
  }, [user.token]); 

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  const fetchCapteurs = useCallback(async () => {
    try {
      const response = await axios.get(`${API_URL}/camera/listcamera?id=${userId}`, {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      });
      setCapteurs(response.data.data);
    } catch (error) {
      console.error("Erreur lors de la récupération des compteurs :", error);
    }
  }, [user.token , userId]);

  useEffect(() => {
    fetchCapteurs();
  }, [fetchCapteurs, userId]); 

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setSelectedCapteur(null);
    setShowMoteurList(true);
  };

  const handleCapteurClick = (capteur) => {
    setSelectedCapteur(capteur.nom_camera || '');
    setSelectedIdCompteur(capteur._id);
    setSearchTerm(capteur.nom_camera || '');
    setShowMoteurList(false);
  };

  const filteredCapteurs = capteurs.filter((capteur) => {
    return (
      (capteur.nom_camera || '').toLowerCase().includes(searchTerm.toLowerCase()) &&
      !capteur.id_user.some((uid) => uid === selectedUserId)
    );
  });

  const linkedCapteurs = capteurs.filter((capteur) =>
    capteur.id_user.some((uid) => uid === selectedUserId)
  );

  const ajouterCompteurUtilisateur = async () => {
    try {
      const response = await axios.post(`${API_URL}/camera/ajoutcamera`, {
        id_user: selectedUserId,
        id_camera: selectedIdCompteur,
      }, {
        headers: {
          mode: "cors",
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + user.token,
        },
      });
      const json = response.data;
      console.log(json.data);
      setSelectedCapteur(null);
      setSelectedIdCompteur(null);
      setSearchTerm("");
      fetchCapteurs();
    } catch (error) {
      console.error(error.message);
    }
  };

  const handleAjouterCompteur = () => {
    ajouterCompteurUtilisateur();
  };

  const retirerCompteurUtilisateur = async (idCamera) => {
    try {
      await axios.post(`${API_URL}/camera/retraitcamera`, {
        id_user: selectedUserId,
        id_camera: idCamera,
      }, {
        headers: {
          mode: "cors",
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + user.token,
        },
      });
      fetchCapteurs();
    } catch (error) {
      console.error("Erreur lors du retrait du compteur :", error.message);
    }
  };

  const deleteUser = async (userId) => {
    try {
      const response = await axios.post(`${API_URL}/user/suppr`, 
        { id: userId }, 
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
  
      if (response.status === 200) {
        fetchUsers();
      } else {
        console.error("Erreur lors de la suppression de l'utilisateur");
      }
    } catch (error) {
      console.error("Erreur lors de la suppression de l'utilisateur :", error);
    }
  };
  

  const updateUser = (updatedUser) => {
    setUsers(users.map(user => user.id === updatedUser.id ? updatedUser : user));
  };

  const toggleAdmin = async (userId, isAdmin) => {
    try {
      const response = await axios.put(`${API_URL}/user/setadmin`, 
        {
          id: userId, 
          isAdmin: isAdmin,
        }, 
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      
      if (response.status === 200) {
        setUsers(users.map(user => 
          user._id === userId ? { ...user, admin: isAdmin } : user
        ));
      }
    } catch (error) {
      console.error("Erreur lors de la mise à jour du rôle admin :", error);
    }
  };
  
  

  useEffect(() => {
    if (selectedUserId) {
      const user = users.find(user => user._id === selectedUserId);
      setSelectedUserEmail(user.email);
    }
  }, [selectedUserId, users]);

  const handleEditClick = (userId, userEmail) => {
    setSelectedUserId(userId);
    setSelectedUserEmail(userEmail);
  };

  const handleCloseEditForm = () => {
    setIsEditing(false);
    setSelectedUserId(null);
    setSelectedUserEmail("");
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-100 text-gray-900">
      <Header user={user} />
      <div className="flex-grow py-12 px-4">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 text-center mb-8">
            Gestion des utilisateurs
          </h1>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
            {/* Colonne gauche : liste des utilisateurs */}
            <div className="bg-white border border-gray-200 shadow-lg rounded-lg p-6 sm:p-8">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-400 to-cyan-400 flex items-center justify-center shrink-0">
                  <FaUserCog className="text-white text-sm" />
                </div>
                <h2 className="text-xl sm:text-2xl font-semibold text-gray-800">Utilisateurs</h2>
              </div>

              {isEditing ? (
                <EditUserForm
                  userId={selectedUserId}
                  userEmail={selectedUserEmail}
                  onClose={handleCloseEditForm}
                  onUpdateUser={updateUser}
                />
              ) : (
                <UserTable
                  users={users}
                  deleteUser={deleteUser}
                  setSelectedUserId={setSelectedUserId}
                  setSelectedUserEmail={setSelectedUserEmail}
                  setAdminRole={(userId, isAdmin) => toggleAdmin(userId, isAdmin)}
                  onEditUser={handleEditClick}
                  selectedUserId={selectedUserId}
                />
              )}
            </div>

            {/* Colonne droite : ajout + gestion utilisateur sélectionné */}
            <div className="flex flex-col gap-8">
              <div className="bg-white border border-gray-200 shadow-lg rounded-lg p-6 sm:p-8">
                <AddUserForm token={user.token} />
              </div>

              {selectedUserId && (
                <div className="bg-white border border-gray-200 shadow-lg rounded-lg p-6 sm:p-8">
                  <div className="flex items-center gap-3 mb-6">
                    <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-indigo-400 flex items-center justify-center shrink-0">
                      <FaUserEdit className="text-white text-sm" />
                    </div>
                    <div className="min-w-0">
                      <h2 className="text-xl sm:text-2xl font-semibold text-gray-800">Modifier</h2>
                      <p className="text-sm text-gray-500 truncate">{selectedUserEmail}</p>
                    </div>
                  </div>

                  <div className="space-y-6">
                    <EditUserForm id={selectedUserId} token={user.token} rafraichir={fetchUsers} />
                    <ChangePasswordForm id={selectedUserId} token={user.token} />

                    <div className="border-t border-gray-100 pt-6">
                      <UserCapteurList
                        linkedCapteurs={linkedCapteurs}
                        onRemove={retirerCompteurUtilisateur}
                      />
                    </div>

                    <div className="border-t border-gray-100 pt-6">
                      <SearchCapteur 
                        searchTerm={searchTerm} 
                        handleSearch={handleSearch} 
                        handleAjouterCompteur={handleAjouterCompteur}
                        selectedCapteur={selectedCapteur} 
                      />

                      {showMoteurList && searchTerm !== "" && filteredCapteurs.length > 0 && (
                        <CapteurList
                          filteredCapteurs={filteredCapteurs}
                          handleCapteurClick={handleCapteurClick}
                        />
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  );
}